module.exports = __webpack_public_path__ + "static/media/okocim.4767bf34.png";